import { Project } from './project';
import { ORGANIZATION } from '../organizations/mock-organization';

export let PROJECT: Project = <Project> {
  id: '00000000-0000-0000-0000-000000000001',
  name: 'Project Title',
  customerOrganization: ORGANIZATION,
  poNumber: '1234'
};
